export default __webpack_public_path__ + "static/media/leisure.2cf0c3b0.svg";